import { render, staticRenderFns } from "./AlertRSFiltersTable.vue?vue&type=template&id=45ccd408&scoped=true&"
import script from "./AlertRSFiltersTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSFiltersTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSFiltersTable.vue?vue&type=style&index=0&id=45ccd408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ccd408",
  null
  
)

export default component.exports